import { BaseOfferStatus } from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../shared/_enums/base-customer-work-council-status.enum';

export enum BaseOfferFilters {
  statuses = 'statuses',
  workCouncilStatus = 'workCouncilStatus',
  departments = 'departments',
  mainQualifications = 'mainQualifications',
  profileAverageRating = 'profileAverageRating',
  pspBranches = 'pspBranches',
  experience = 'experience',
  search = 'search',
}

export const BASE_CUSTOMER_WORK_COUNCIL_OFFER_STATUS_OPTIONS = [
  { name: 'action.offered', id: BaseOfferStatus.open.toString(), class: 'offer-offered-filter-state' },
  { name: 'action.preselected', id: BaseOfferStatus.preselected.toString(), class: 'offer-preselected-filter-state' },
  {
    name: 'shiftStatus.legend.needsOwnConfirmation',
    id: BaseOfferStatus.needsConfirmation.toString(),
    class: 'inquiry-closed-filter-state',
  },
];

export const BASE_CUSTOMER_WORK_COUNCIL_APPROVAL_OPTIONS = [
  {
    name: 'action.approvedOfWorkCouncil',
    value: BaseCustomerWorkCouncilStatusEnum.APPROVED,
    class: 'offer-accepted-filter-state',
  },
  {
    name: 'action.notedOfWorkCouncil',
    value: BaseCustomerWorkCouncilStatusEnum.NOTED,
    class: 'offer-accepted-filter-state',
  },
  {
    name: 'action.disapprovedOfWorkCouncil',
    value: BaseCustomerWorkCouncilStatusEnum.DISAPPROVED,
    class: 'offer-declined-filter-state',
  },
];

export enum BaseCustomerOfferStatusChangeActions {
  accept = 'accept',
  reject = 'reject',
  withdrawAndReject = 'withdrawApprovalAndReject',
}

export enum BaseCustomerOfferPreselectionChangeActions {
  preselect = 'preselect',
  unselect = 'unselect',
}
